import { render, staticRenderFns } from "./ConfirmEmailAction.vue?vue&type=template&id=c0d950d4&scoped=true"
import script from "./ConfirmEmailAction.vue?vue&type=script&lang=js"
export * from "./ConfirmEmailAction.vue?vue&type=script&lang=js"
import style0 from "./ConfirmEmailAction.vue?vue&type=style&index=0&id=c0d950d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d950d4",
  null
  
)

export default component.exports